const state = {
  // Хранилище путей к изображениям для каждого блока
  blockImagePaths: {},

  // Текущий открытый блок в ImageViewer
  currentImageViewer: {
    isVisible: false,
    title: '',
    images: [],
    currentPage: 1,
    blockId: null,
  },

  // Кэш для избежания повторной генерации путей
  imagePathsGenerated: false,
};

const mutations = {
  // Установка путей к изображениям для конкретного блока
  SET_BLOCK_IMAGE_PATHS(state, { blockId, imagePaths }) {
    state.blockImagePaths = {
      ...state.blockImagePaths,
      [blockId]: imagePaths,
    };
  },

  // Установка всех путей к изображениям сразу
  SET_ALL_IMAGE_PATHS(state, allImagePaths) {
    state.blockImagePaths = allImagePaths;
    state.imagePathsGenerated = true;
  },

  // Открытие ImageViewer с данными
  OPEN_IMAGE_VIEWER(state, { title, blockId, currentPage = 1 }) {
    const images = state.blockImagePaths[blockId] || [];
    state.currentImageViewer = {
      isVisible: true,
      title,
      images,
      currentPage,
      blockId,
    };
  },

  // Закрытие ImageViewer
  CLOSE_IMAGE_VIEWER(state) {
    state.currentImageViewer = {
      isVisible: false,
      title: '',
      images: [],
      currentPage: 1,
      blockId: null,
    };
  },

  // Изменение текущей страницы в ImageViewer
  SET_CURRENT_PAGE(state, page) {
    state.currentImageViewer.currentPage = page;
  },

  // Сброс состояния генерации путей
  RESET_IMAGE_PATHS_GENERATED(state) {
    state.imagePathsGenerated = false;
  },
};

const actions = {
  // Генерация путей к изображениям для всех блоков
  generateAllImagePaths({ commit, state }) {
    // Если пути уже сгенерированы, не генерируем повторно
    if (state.imagePathsGenerated) {
      return;
    }

    const allImagePaths = {};

    // Конфигурация блоков и количества изображений
    const blockConfigs = [
      { blockId: 'block-1', blockNumber: 1, photoCount: 2 /* 24 */ },
      { blockId: 'block-2', blockNumber: 2, photoCount: 2 /* 125  */ },
      // { blockId: 'block-3', blockNumber: 3, photoCount: 24 },
      // { blockId: 'block-4', blockNumber: 4, photoCount: 24 },
    ];

    // Webpack-friendly dynamic import context for images
    const imagesContext = require.context('../../assets/img/backoffice', true, /\.png$/);

    blockConfigs.forEach(({ blockId, blockNumber, photoCount }) => {
      const images = [];
      const blockIdFormatted = blockNumber.toString().padStart(2, '0'); // Convert 1 to "01", 2 to "02", etc.

      for (let i = 1; i <= photoCount; i++) {
        const key = `./block-${blockIdFormatted}/slide_${i}.png`;
        try {
          const imagePath = imagesContext(key);
          images.push(imagePath);
        } catch (error) {
          console.warn(`Block-${blockIdFormatted} image ${key} not found`);
        }
      }

      allImagePaths[blockId] = images;
    });

    commit('SET_ALL_IMAGE_PATHS', allImagePaths);
  },

  // Открытие ImageViewer для конкретного курса
  openCourseImageViewer({ commit, state, rootState }, payload) {
    // Убеждаемся, что пути к изображениям сгенерированы
    if (!state.imagePathsGenerated) {
      console.warn('Image paths not generated yet. Call generateAllImagePaths first.');
      return;
    }

    // Handle both old format { course, parentBlock } and new format { blockId, title, slideNumber }
    let title, blockId, currentPage;

    if (payload.course && payload.parentBlock) {
      // Old format
      title = payload.parentBlock.title;
      blockId = payload.parentBlock.id;
      currentPage = payload.course.slideNumber || 1;
    } else if (payload.blockId && payload.title) {
      // New format
      title = payload.title;
      blockId = payload.blockId;
      currentPage = payload.slideNumber || 1;
    } else {
      console.warn('Invalid payload format for openCourseImageViewer:', payload);
      return;
    }

    commit('OPEN_IMAGE_VIEWER', {
      title,
      blockId,
      currentPage,
    });
  },

  // Закрытие ImageViewer
  closeImageViewer({ commit }) {
    commit('CLOSE_IMAGE_VIEWER');
  },

  // Изменение текущей страницы
  setCurrentPage({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },

  // Сброс и повторная генерация путей
  resetAndRegenerateImagePaths({ commit, dispatch }) {
    commit('RESET_IMAGE_PATHS_GENERATED');
    dispatch('generateAllImagePaths');
  },
};

const getters = {
  // Получение путей к изображениям для конкретного блока
  getBlockImagePaths: (state) => (blockId) => {
    return state.blockImagePaths[blockId] || [];
  },

  // Получение всех путей к изображениям
  getAllImagePaths: (state) => {
    return state.blockImagePaths;
  },

  // Получение состояния ImageViewer
  getImageViewer: (state) => {
    return state.currentImageViewer;
  },

  // Проверка, сгенерированы ли пути
  areImagePathsGenerated: (state) => {
    return state.imagePathsGenerated;
  },

  // Получение количества изображений для блока
  getBlockImageCount: (state) => (blockId) => {
    return state.blockImagePaths[blockId]?.length || 0;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
